import { Box } from "@mui/material";

export const ContentContainer = ({ children }) => {
  return <Box mx={["10px", "10px", "auto"]}>{children}</Box>;
};
